import { render, staticRenderFns } from "./modalMd.vue?vue&type=template&id=b6d03406&"
import script from "./modalMd.vue?vue&type=script&lang=js&"
export * from "./modalMd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports